document.addEventListener("DOMContentLoaded", () => {
  const quantityUpsellEls = document.querySelectorAll(
    ".quantity-upsell [data-quantity]"
  );

  quantityUpsellEls.forEach((quantityUpsell) => {
    quantityUpsell.addEventListener("click", (event) => {
      const quantity = event?.target?.dataset?.quantity;
      const quantityEl = document.querySelector(
        '[action*="cart/add"] [name="quantity"]'
      );

      if (quantity && quantityEl) {
        quantityEl.value = quantity;
        quantityEl.dispatchEvent(new Event("input"));
      }

      const atc = document.querySelector(
        '#teeAtcButton, [action*="cart/add"] [type="submit"]'
      );

      if (atc) {
        atc.scrollIntoView({ behavior: "smooth", block: "end" });
        setTimeout(() => {
          atc.click();
        }, 200);
      }
    });
  });
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const intervalId = setInterval(() => {
    const insertAfterElement = document.querySelector(".calculoFrete");

    if (insertAfterElement) {
      const elementToMove = document.querySelector(".quantity-upsell");
      if (elementToMove) {
        insertAfterElement.after(elementToMove);
      }
      clearInterval(intervalId);
    }
  }, 500);
});

/**
 * VERSAO REVISADA (candidata a substituir a versao publicada em 02/09 e
 * ajustada em 16/09) — pendente de teste antes de ir para o tema ao vivo.
 *
 * Objetivo original (mantido): permitir que o usuario va para a proxima
 * imagem/produto sem precisar esperar a barra de progresso do editor de
 * recorte do Teeinblue chegar a 100%.
 *
 * MUDANCA em relacao a versao anterior: a versao anterior simulava um
 * clique no botao de fechar (X) real do Teeinblue (".tee-dialog-close")
 * assim que a chamada "apply-effects" era detectada. Isso e suspeito de
 * ser a causa do salto de erros "Failed to fetch"/"Load failed" desde
 * 02/09/2026 (e do pico maior em 16/09, quando esse mesmo bloco foi
 * ajustado): clicar no X real do Teeinblue provavelmente aciona a logica
 * interna deles de "usuario cancelou, aborte o upload em andamento" —
 * o que faz a propria chamada de rede deles falhar.
 *
 * Esta versao NAO clica em nada que pertenca ao Teeinblue. Em vez disso,
 * apenas ESCONDE visualmente o modal via CSS (opacity 0, tirado da tela,
 * sem eventos de clique) assim que "apply-effects" e detectado. O usuario
 * tem a mesma experiencia (a janela "some" na hora), mas a chamada de
 * rede do Teeinblue nunca recebe nenhum sinal de cancelamento — ela
 * continua rodando em segundo plano normalmente ate o Teeinblue mesmo
 * terminar de processar (sucesso ou erro real deles).
 *
 * COMO TESTAR COM SEGURANCA (sem afetar a loja ao vivo):
 *   1. Shopify Admin > Loja Online > Temas > Acoes (...) no tema atual
 *      > "Duplicar" (isso cria uma copia identica, nao publicada).
 *   2. Na copia duplicada: Editar codigo > assets > teeinblue-custom.js
 *      > colar este arquivo inteiro, substituindo o conteudo atual.
 *   3. Na lista de temas, clique em "Visualizar loja" (Preview) na copia
 *      duplicada — isso abre a loja real com ESSE tema, sem publicar,
 *      sem afetar quem esta comprando agora.
 *   4. Repita o fluxo de personalizar um produto/selecionar foto varias
 *      vezes seguidas (como um cliente ansioso faria) e confira: (a) o
 *      popup ainda "some" rapido como antes, (b) a foto realmente sobe e
 *      aparece certinho no card do produto, (c) abrir o console do
 *      navegador (F12) e ver se o "Failed to fetch"/"Load failed" ainda
 *      aparece nessas interacoes.
 *   5. Só publicar esse tema (tornar principal) depois de validar o
 *      passo 4. Depois de publicado, comparar o volume diario de erro no
 *      Datadog nas 24-48h seguintes com o patamar de 23-31/08 (240-762
 *      erros/dia) — se cair para perto disso, confirma a hipotese.
 */
(function () {
  if (window.__teeinblueCropperAutoHideBound) return;
  window.__teeinblueCropperAutoHideBound = true;

  var APPLY_EFFECTS_MATCH = "apply-effects";
  var HIDDEN_CLASS = "tee-host-hidden-while-uploading";
  var SAFETY_REVEAL_MS = 45000; // devolve a visibilidade se nada acontecer em 45s (rede muito lenta / falha silenciosa do lado deles)
  var pendingModal = null;

  function ensureHiddenStyle() {
    if (document.getElementById("tee-host-hidden-style")) return;
    var style = document.createElement("style");
    style.id = "tee-host-hidden-style";
    style.textContent =
      "." + HIDDEN_CLASS + "{opacity:0!important;pointer-events:none!important;" +
      "position:fixed!important;left:-9999px!important;top:-9999px!important;}";
    document.head.appendChild(style);
  }

  function hidePendingModal() {
    if (!pendingModal) return;
    var modal = pendingModal;
    pendingModal = null;
    if (!document.body.contains(modal)) return;

    ensureHiddenStyle();
    modal.classList.add(HIDDEN_CLASS);

    // Rede de seguranca: se por algum motivo nada acontecer (Teeinblue
    // nunca remover/atualizar esse modal sozinho), devolvemos a
    // visibilidade depois de um tempo generoso, so por higiene — isso
    // NAO cancela nada, so evita um elemento invisivel preso pra sempre.
    setTimeout(function () {
      if (document.body.contains(modal)) {
        modal.classList.remove(HIDDEN_CLASS);
      }
    }, SAFETY_REVEAL_MS);
  }

  // 1) Detecta o clique em "Selecionar" e memoriza qual popup deve ser
  //    escondido assim que a requisicao correspondente for enviada.
  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      var confirmBtn = target.closest(
        ".tee-dialog-image-cropper .tee-cropper-footer .tee-btn--primary"
      );
      if (!confirmBtn) return;

      var modal = confirmBtn.closest(
        ".vm--container.tee-dialog-image-cropper"
      );
      if (!modal) return;

      pendingModal = modal;
    },
    true
  );

  // 2) Intercepta fetch() so para DETECTAR o envio do apply-effects —
  //    nunca modifica a chamada em si (return originalFetch.apply
  //    continua identico a antes).
  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function (input, init) {
      try {
        var url =
          typeof input === "string" ? input : (input && input.url) || "";

        if (pendingModal && url.indexOf(APPLY_EFFECTS_MATCH) !== -1) {
          hidePendingModal();
        }
      } catch (e) {
        /* nunca deixa esse detector quebrar o app da TeeinBlue */
      }

      return originalFetch.apply(this, arguments);
    };
  }

  // 3) Intercepta XMLHttpRequest tambem, caso a TeeinBlue use XHR em vez
  //    de fetch em algum navegador/fluxo.
  var originalXhrOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (
        pendingModal &&
        typeof url === "string" &&
        url.indexOf(APPLY_EFFECTS_MATCH) !== -1
      ) {
        hidePendingModal();
      }
    } catch (e) {
      /* nunca deixa esse detector quebrar o app da TeeinBlue */
    }

    return originalXhrOpen.apply(this, arguments);
  };
})();